import Entity from './Entity'
export default class Credential extends Entity {
  id
  name
}
